import React, { useState, useEffect } from "react";
import "../App.css";
import Axios from "axios";
import user from "../assets/images/user.png";
import { useNavigate } from "react-router-dom";
import healthprofile from "../assets/images/healthprofile.jpg";
import consulthistory from "../assets/images/consulthistory.jpg";
import doctorsicon from "../assets/images/doctorsicon.png";
import medicalrecords from "../assets/images/medicalrecords.png";
import contact from "../assets/images/contactLogo.png";
import editicon from "../assets/images/editicon.png";
import vital from "../assets/images/vital.png";
import downArrow from "../assets/images/down_arrow.gif";
import others from "../assets/images/other.png";
import { useRecoilState } from "recoil";
import { message } from "antd";
import { is_patient_profile_data_updated, patient_profile_image, patient_profile_image_show, patient_medical_data_loading, patient_medical_tracking_details, is_patient_custom_medical_data_updated, } from "../Store/PatientProfileDetails";
import LandingPage from "./LandingPage";
import logout from "../assets/images/logout.svg";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { FcPlus } from "react-icons/fc";

export default () => {
  const moment = require("moment");
  const [phoneNo, setPhoneNo] = useState("");
  const [patientDetails, setPatientDetails] = useState([]);
  const [medicaltrackingData, setMedicaltrackingData] = useRecoilState(patient_medical_tracking_details);
  const [customMedicaltrackingData, setCustomMedicaltrackingData] = useState([]);
  const [profileImg, setProfileImg] = useRecoilState(patient_profile_image);
  const [isprofileImgUpdated, setIsprofileImgUpdated] = useRecoilState(patient_profile_image_show);
  const [isMedicalTrackingDataUpdated, setIsMedicalTrackingDataUpdated] = useRecoilState(patient_medical_data_loading);
  const [isCustomMedicalTrackingDataUpdated, setIsCustomMedicalTrackingDataUpdated,] = useRecoilState(is_patient_custom_medical_data_updated);
  const [isProfileUpdated, setIsProfileUpdated] = useRecoilState(is_patient_profile_data_updated);
  const [isSigneIn, setIsSigneIn] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();
  let id;
  const handleCloseModal = (e) => { setModalOpen(false); };
  const baseURL = process.env.REACT_APP_GLOBAL_BASEURL;
  const token = localStorage.getItem("token");
  const headers = { Authorization: `Bearer ${token}`, };

  const getAllMedicalCustomTrackingDataJwtToken = async () => {
    try {
      if (
        isCustomMedicalTrackingDataUpdated == true ||
        customMedicaltrackingData == ""
      ) {
        if (localStorage.getItem("patientid")) {
          console.log("IDDDDDDDD::::", `${process.env.REACT_APP_GLOBAL_BASEURL
            }/api/patientapi/PatientHealthTracking/get_all_medical_custom_tracking_data?patients_id_fk=${localStorage.getItem(
              "patientid"
            )},&MDT=PM`, `Bearer ${token}`);
          const response = await Axios.get(
            `${process.env.REACT_APP_GLOBAL_BASEURL
            }/api/patientapi/PatientHealthTracking/get_all_medical_custom_tracking_data?patients_id_fk=${localStorage.getItem(
              "patientid"
            )}&MDT=PM&user_role=rp`,
            { headers }
          );
          if (response.data.status == '1') {
            if (response.data.data.length > 0) {
              setCustomMedicaltrackingData(response.data.data);
              setIsCustomMedicalTrackingDataUpdated(false);
            }
          } else if (response.data.status == '401') {
            console.log("Unauthorized access. Logging out.");
            message.error("Session expired, please re-login!!");
            logoutHandler();
          } else if (response.data.status == '0') {
            message.error("Failed to fetch data!!");
          }
        }
      } else {
        const response = await Axios.get(
          `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/get_all_medical_custom_tracking_data?patients_id_fk=${id}&MDT=PM&user_role=rp`,
          { headers }
        );
        if (response.data.status == '1') {
          if (response.data.data.length > 0) {
            setCustomMedicaltrackingData(response.data.data);
            setIsCustomMedicalTrackingDataUpdated(false);
          }
        } else if (response.data.status == '401') {
          console.log("Unauthorized access. Logging out.");
          message.error("Session expired, please re-login!!");
          logoutHandler();
        } else if (response.data.status == '0') {
          message.error("Failed to fetch data!!");
        }
      }
    } catch (error) {
      if (error.response && error.response.status == '401') {
        console.error("Unauthorized access. Logging out.");
        message.error(error.response.data.message);
        logoutHandler();
      } else {
        console.error("Error:", error.message);
      }
    }
  };

  const getAllmedicalTrackingDataJwtToken = async () => {
    try {
      if (isMedicalTrackingDataUpdated == true || medicaltrackingData == "") {
        if (localStorage.getItem("patientid")) {
          Axios.get(
            `${process.env.REACT_APP_GLOBAL_BASEURL
            }/api/patientapi/PatientHealthTracking/get_all_medical_tracking_data?patients_id_fk=${localStorage.getItem(
              "patientid"
            )}&MDT=PM&user_role=rp`,
            { headers }
          ).then((response) => {
            console.log(response.data);
            if (response.data.status == "1") {
              if (response.data.data.length > 0) {
                setMedicaltrackingData(response.data.data);
                setIsMedicalTrackingDataUpdated(false);
              } else {
                setMsg("No data is availble");
              }
            } else if (response.data.status == '401') {
              console.log("Unauthorized access. Logging out.");
              message.error("Session expired, please re-login!!");
              logoutHandler();
            } else if (response.data.status == '0') {
              message.error("Failed to fetch data!!");
            }
          });
        }
      } else {
        Axios.get(
          `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/get_all_medical_tracking_data?patients_id_fk=${id}&MDT=PM&user_role=rp`,
          { headers }
        ).then((response) => {
          console.log(response.data);
          if (response.data.status == "1") {
            if (response.data.data.length > 0) {
              setMedicaltrackingData(response.data.data);
              setIsMedicalTrackingDataUpdated(false);
            } else {
              setMsg("No data is availble");
            }
          } else if (response.data.status == '401') {
            console.log("Unauthorized access. Logging out.");
            message.error("Session expired, please re-login!!");
            logoutHandler();
          } else if (response.data.status == '0') {
            message.error("Failed to fetch data!!");
          }
        });
      }
    } catch (error) {
      if (error.response && error.response.status == '401') {
        console.error("Unauthorized access. Logging out.");
        message.error(error.response.data.message);
        logoutHandler();
      } else {
        console.error("Error:", error.message);
      }
    }
  };

  useEffect(() => {
    console.log("hii");
    let phoneno = localStorage.getItem("phoneNo");
    if(!phoneno){
      logoutHandler()
    }
    setMsg("");
    if (localStorage.getItem("token")) {
      setIsSigneIn(true);
      console.log("localStoragePhoneNo", localStorage.getItem("phoneNo"));
      let patientLocalData = JSON.parse(
        localStorage.getItem("patientLocalData")
      );
      console.log("Home useEffect: patientLocalData= ", patientLocalData);
      if (
        patientLocalData == null ||
        patientLocalData == "" ||
        isProfileUpdated == true ||
        isprofileImgUpdated == true ||
        profileImg == ""
        // || isMedicalTrackingDataUpdated == true || medicaltrackingData == "" || customMedicaltrackingData == ""
      ) {
        try {
          Axios.get(
            `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientBioProfile/alldetails?phone=${phoneno}&MDT=PM&user_role=rp`,
            { headers }
          ).then((response) => {
            console.log("patient's all data", response.data.data[0]);
            if (response.data.status == "1") {
              id = response.data.data[0].id;
              localStorage.setItem("patientid", id);
              console.log("patientid=", id);
              setPatientDetails(response.data.data[0]);
              localStorage.setItem(
                "patientLocalData",
                JSON.stringify(response.data.data[0])
              );
              localStorage.setItem(
                "patientUniqueId",
                response.data.data[0].up_id
              );
              setIsProfileUpdated(false);
            } else if (response.data.status == '401') {
              console.log("Unauthorized access. Logging out.");
              message.error("Session expired, please re-login!!");
              logoutHandler();
            } else if (response.data.status == '0') {
              message.error("Failed to fetch data!!");
            }
            Axios.get(
              `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/File_reader/read_file_content_patient?patientid=${response.data.data[0].up_id}&file=${response.data.data[0].profile_image}&MDT=PM&user_role=rp`
            ).then((response) => {
              console.log("buffer file = ", response.data);
              setProfileImg(response.data.base64String);
              setIsprofileImgUpdated(false);
            });
            getAllmedicalTrackingDataJwtToken();
            getAllMedicalCustomTrackingDataJwtToken();
          });
        } catch (error) {
          if (error.response && error.response.status == '401') {
            console.error("Unauthorized access. Logging out.");
            message.error(error.response.data.message);
            logoutHandler();
          } else {
            console.error("Error:", error.message);
          }
        }
      } else {
        setPatientDetails(patientLocalData);
      }
      console.log(localStorage.getItem("patientid"));
      if (isMedicalTrackingDataUpdated == true || medicaltrackingData == "") {
        if (localStorage.getItem("patientid")) {
          getAllmedicalTrackingDataJwtToken();
        }
      }
      if (
        isCustomMedicalTrackingDataUpdated == true ||
        customMedicaltrackingData == ""
      ) {
        if (localStorage.getItem("patientid")) {
          console.log("getAllMedicalCustomTrackingDataJwtToken: Updated");
          getAllMedicalCustomTrackingDataJwtToken();
        }
      }
    } else {
      setIsSigneIn(false);
    }
  }, []);

  const goToHealthProfile = () => {
    navigate("/PatientHealthProfile", { state: phoneNo });
  };
  const goToAddRecords = () => {
    navigate("/MedicalRecords", { state: phoneNo });
  };
  const goToConsultationHistory = () => {
    navigate("/ConsultationHistoryList", { state: phoneNo });
  };
  const goToDoctors = () => {
    navigate("/MyDoctors", { state: phoneNo });
  };
  const goToEditProfile = () => {
    navigate("/EditProfile", { state: patientDetails });
  };
  const goToContactUs = () => {
    navigate("/Tickets");
  };
  const goToSelectVitals = () => {
    navigate("/SelectVitals");
  };

  const logoutHandler = () => {
    localStorage.removeItem("phoneNo");
    localStorage.removeItem("patientid");
    localStorage.removeItem("patientLocalImage");
    localStorage.removeItem("patientLocalData");
    localStorage.removeItem("patientUniqueId");
    localStorage.removeItem("chronic_illness_data");
    localStorage.removeItem("allergic_information_data");
    localStorage.removeItem("family_relation_data");
    localStorage.removeItem("family_disease_data");
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");

    setProfileImg("");
    setIsMedicalTrackingDataUpdated("");
    setIsCustomMedicalTrackingDataUpdated("");
    setIsprofileImgUpdated("");
    setIsProfileUpdated("");
    setMedicaltrackingData("");
    setIsSigneIn(false);
    navigate("/Login");
  };

  return (
    <div className="background-container">
      {isSigneIn ? (
        <>
          <Dialog
            open={modalOpen}
            onClose={handleCloseModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Are you sure you want to Logout?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description"></DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseModal}>Cancel</Button>
              <Button onClick={logoutHandler} type="submit" autoFocus>
                Logout
              </Button>
            </DialogActions>
          </Dialog>
          <div
            className="patient_details"
            style={{
              // background: "#639beb",
              background: "#FFFFFF",
              display: "flex",
              borderRadius: "50px 0 0 50px",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "20px",
              margin: " 0 0 10px 0"
            }}
          >
            <div style={{ display: "flex", flexDirection: "row", }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "56px",
                  height: "56px",
                  borderRadius: "50%",
                  padding: "2px",
                  boxSizing: "border-box",
                  background: "linear-gradient(90deg, blue, green, pink, red, pink, green, blue)", // Gradient
                  backgroundSize: "200% 200%", // Enlarged background for smooth animation
                  animation: "moveGradient 6s infinite linear", // Moves the gradient smoothly
                }}
                onClick={goToEditProfile}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#fff",
                    width: "48px",
                    height: "48px",
                    borderRadius: "50%",
                    padding: "4px",
                    boxSizing: "border-box",
                  }}
                >
                  <img
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "50%",
                    }}
                    src={profileImg || user}
                  />
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", marginLeft: 10 }}>
                <p style={{ fontSize: 14, color: "black" }}>
                  <strong style={{ fontWeight: "bold" }}>Name: </strong>{patientDetails.first_name} {patientDetails.last_name}
                </p>
                <p style={{ fontSize: 14, color: "black" }}>
                  <strong style={{ fontWeight: "bold" }}>Unique Id: </strong>{patientDetails.up_id}
                </p>
              </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                {baseURL === "https://testemr-api-php.cb-dev.in" && (
                  <strong style={{ marginBottom: 5, fontSize: 11 }}>Test</strong>
                )}
                <img
                  onClick={() => setModalOpen(true)}
                  src={logout}
                  style={{
                    height: 25,
                    width: 25,
                    cursor: "pointer",
                  }}
                  alt="Log Out"
                />
              </div>
            </div>
          </div>

          <div
            style={{
              backgroundColor: "white",
              padding: 10,
              margin: "10px 20px",
              borderRadius: 15,
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)", // 4 equal-sized columns
                gap: "10px", // Space between items
              }}
            >
              {[
                // { title: "Bio Profile", icon: editicon, onClick: goToEditProfile },
                { title: "Health Profile", icon: healthprofile, onClick: goToHealthProfile },
                { title: "Your Consultation", icon: consulthistory, onClick: goToConsultationHistory },
                { title: "Medical Records", icon: medicalrecords, onClick: goToAddRecords },
                { title: "My Doctors", icon: doctorsicon, onClick: goToDoctors },
                { title: "Customer Support", icon: contact, onClick: goToContactUs },
                { title: "Medical Tracking", icon: vital, onClick: goToSelectVitals },
              ].map(({ title, icon, onClick }, index) => (
                <button
                  key={index}
                  onClick={onClick}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "top",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    padding: "10px",
                    width: "100%", // Make items flexible
                    height: "100%", // Adjust height automatically
                  }}
                >
                  <div
                    style={{
                      height: "50px",
                      width: "50px",
                      backgroundColor: "#e0e0e0", // Ash color background
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <img
                      src={icon}
                      alt={`${title} icon`}
                      style={{
                        height: "20px",
                        width: "20px",
                      }}
                    />
                  </div>
                  <span style={{ fontSize: "12px", fontWeight: "500", color: "#333" }}>
                    {title}
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div
            className="latest-medical-records"
            style={{
              backgroundColor: "#FFFFFF", // Outer card with white background
              margin: "10px 20px",
              borderRadius: "15px", // Optional: Adding border radius for a cleaner look
              padding: "10px", // Padding for some space inside the outer card
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  fontSize: 17,
                  fontWeight: "bold",
                  color: "black",
                }}
              >
                Medical Tracking Info
              </p>
              <img style={{ height: 20, width: 20, marginLeft: 10 }} src={downArrow} />
            </div>

            {msg ? (
              <p
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  color: "red",
                  fontSize: 12,
                  fontWeight: "bold",
                }}
              >
                {msg}
              </p>
            ) : null}

            {/* Scrollable container for medical tracking data */}
            <div
              style={{
                maxHeight: "350px", // Adjust the height as needed
                overflowY: "scroll", // Keep scrolling enabled
                paddingRight: "10px", // Optional: Add padding to avoid scrollbar touching content
                scrollbarWidth: "none", // For Firefox
                msOverflowStyle: "none", // For Internet Explorer
              }}
            >
              {/* Medical Tracking Data */}
              {medicaltrackingData &&
                medicaltrackingData.map((val, index) => {
                  // Parse min_value, max_value, and values into arrays
                  const minValues = val.min_value.split(",").map(Number);
                  const maxValues = val.max_value.split(",").map(Number);
                  const values = val.value.split("/").map((v) => v.trim()).map(Number);

                  // Function to determine the text color for each value
                  const getTextColor = (value, min, max) => {
                    if (value < min) return "red";
                    if (value > max) return "orange";
                    return "green";
                  };

                  return (
                    <div
                      key={val.tracking_id}
                      onClick={() =>
                        navigate("/editVitals", {
                          state: { orginalValue: val },
                        })
                      }
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center", // Items aligned in row
                        borderBottom:
                          customMedicaltrackingData.length === 0 &&
                            index === medicaltrackingData.length - 1
                            ? "none"
                            : "1px solid #ccc",
                        padding: "5px 0", // Padding between rows for spacing
                      }}
                    >
                      {/* Left side: Icon and Tracking Type */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={`${process.env.REACT_APP_GLOBAL_BASEURL}/patient_tracking_icon/${val.icon}`}
                          className="latest-vital-cards-img"
                          style={{ marginRight: 10 }} // Space between icon and text
                        />
                        <p
                          style={{
                            fontWeight: "500",
                            fontSize: 12,
                            color: "black"
                          }}
                        >
                          {val.tracking_type}
                        </p>
                      </div>

                      {/* Right side: Value and Date (with top-bottom alignment) */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column", // Change to column to align items vertically
                          justifyContent: "space-between", // Distribute space evenly between date and value
                          alignItems: "flex-end", // Aligning to the right
                          flexGrow: 1, // Allowing right side to take full remaining space
                          height: "50px", // Ensuring enough space to align them top-bottom
                        }}
                      >
                        <p style={{ marginBottom: 0, fontSize: 12, fontWeight: "bold", color: "black" }}>
                          {moment(val.create_datetime).format("DD.MM.YYYY")}
                        </p>
                        {/* Apply text colors for each value and display with "/" separator */}
                        <p style={{ marginTop: 0, fontSize: 12, fontWeight: "bold" }}>
                          {values.map((value, idx) => (
                            <span
                              key={idx}
                              style={{
                                color: getTextColor(
                                  value,
                                  minValues[idx] || 0,
                                  maxValues[idx] || 0
                                ),
                              }}
                            >
                              {value}
                              {/* Add "/" after each value except the last one */}
                              {idx < values.length - 1 && " / "}
                            </span>
                          ))}
                        </p>
                      </div>
                    </div>
                  );
                })}


              {/* Custom Medical Tracking Data */}
              {customMedicaltrackingData &&
                customMedicaltrackingData.map((val, index) => {
                  return (
                    <div
                      key={val.value}
                      onClick={() =>
                        navigate("/customEditVitals", { state: val })
                      }
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        borderBottom:
                          index === customMedicaltrackingData.length - 1
                            ? "none"
                            : "1px solid #ccc", // No border for the last item
                        padding: "10px 0", // Padding between rows for spacing
                      }}
                    >
                      {/* Left side: Icon and Tracking Name */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={others}
                          className="latest-vital-cards-img"
                          style={{ marginRight: 10 }}
                        />
                        <p
                          style={{
                            fontWeight: "500",
                            fontSize: 12,
                            color: "black"
                          }}
                        >
                          {val.tracking_name}
                        </p>
                      </div>

                      {/* Right side: Tracking Value and Date (top-bottom alignment) */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column", // Change to column to align items vertically
                          justifyContent: "space-between", // Distribute space evenly between date and value
                          alignItems: "flex-end", // Aligning to the right
                          flexGrow: 1, // Allowing right side to take full remaining space
                          height: "50px", // Ensure enough space for top-bottom alignment
                        }}
                      >
                        <p style={{ marginBottom: 0, fontSize: 12, fontWeight: "bold", color: 'black' }}>
                          {moment(val.latest_date).format("DD.MM.YYYY")}
                        </p>
                        <p style={{ marginTop: 0, fontSize: 12, color: 'green', fontWeight: "bold" }}>
                          {val.tracking_value}
                        </p>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>

        </>
      ) : (
        <LandingPage />
      )}
    </div>
  );
};
